import { useCallback } from 'react';

import { useEffectMounted } from 'hooks/useEffectMounted';
import { useEffectUnmounted } from 'hooks/useEffectUnmounted';
import { createGlobalState } from 'utils/create-global-state';

type useLoadingProps = {
  loading: boolean;
};

const globalValue = createGlobalState<useLoadingProps>({
  loading: false,
});

export function useLoading(
  loading?: boolean
): [
  useLoadingProps,
  {
    disableLoading: () => void;
    enableLoading: () => void;
  }
] {
  loading = loading || false;
  const [state, setState] = globalValue();

  useEffectMounted(() => {
    setState({
      loading: loading as boolean,
    });
  });
  useEffectUnmounted(() => {
    setState({
      loading: false,
    });
  });

  const disableLoading = useCallback((): void => {
    setState({
      loading: false,
    });
  }, [setState]);

  const enableLoading = useCallback((): void => {
    setState({
      loading: true,
    });
  }, [setState]);

  return [state, { disableLoading, enableLoading }];
}
